import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from "axios";

const ManagerNavbar = () => {

    const [firstname, setfirstname] = useState("")
    const [lastname, setlastname] = useState("")
    const mangerId = localStorage.getItem('ManegerId');

    useEffect(() => {

        LoadUser();

    }, [])

    const LoadUser = () => {

        const datavalue = {
            Usetid: mangerId
        }
        let token = null;
        try {
            const raw = localStorage.getItem("state");
            if (raw) {
                const state = JSON.parse(raw);
                token = state.auth?.token;
            }
        } catch (e) {
            console.error("Token parsing failed", e);
        }
        var authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/getManagerById`,
            data: datavalue,
            headers: { 'Content-Type': 'multipart/form-data', ...(token && { "Authorization": `Bearer ${token}` }) },
        };
        axios(authOptions)
            // axios.post(`https://localhost:7261/getIntentsByid`, datavalue, config)
            .then(res => {
                console.log("get value", res.data);
                // console.log("list", res.data[0].first_Name)
                // setIntentList(res.data)
                // "firstname":"md","lastname":"gdff","emailid":"dfdf","phone":"465456465","address":"fdsfdfsd"}
                // setName({ first: res.data.result[0].firstname, last: res.data.result[0].lastname,
                //               email: res.data.result[0].emailid, phone: res.data.result[0].phone, 
                //               addr: res.data.result[0].address});
                setfirstname(res.data[0]?.first_Name)
                setlastname(res.data[0]?.last_Name)
            })
    }

    const Logout = () => {

        localStorage.removeItem("isAuthenticated");
        localStorage.removeItem("ManegerId");
        localStorage.removeItem("URole");
        localStorage.removeItem("PatientId");
        localStorage.removeItem("PatName");
        localStorage.removeItem("PatQusId");
        localStorage.removeItem("state");
        window.location.href = "/";
    }

    return (
        <>
            <div>
                {/* <ul className="nav navbar-nav navbar-left in">
                    <li><a href="#" className="menu-toggler sidebar-toggler"><i data-feather="menu"></i></a></li>
                </ul> */}

                {/* <!-- start mobile menu --> */}
                <a className="menu-toggler responsive-toggler" data-bs-toggle="collapse" data-bs-target=".navbar-collapse">
                    <span></span>
                </a>
                {/* <!-- end mobile menu --> */}
                {/* <!-- start header menu --> */}
                <div className="top-menu">
                    <ul className="nav navbar-nav pull-right">
                        {/* <!-- start language menu --> */}
                        <li className="dropdown language-switch">
                            <a className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"> <img
                                src="" className="position-left" alt="" />
                            </a>

                        </li>
                        {/* <!-- end language menu --> */}
                        {/* <!-- start notification dropdown --> */}
                        <li className="dropdown dropdown-extended dropdown-notification" id="header_notification_bar">

                            <ul className="dropdown-menu">
                                <li className="external">
                                    <h3><span className="bold">Notifications</span></h3>
                                    <span className="notification-label purple-bgcolor">New 6</span>
                                </li>
                                <li>
                                    <ul className="dropdown-menu-list small-slimscroll-style" data-handle-color="#637283">
                                        <li>
                                            <a href="javascript:;">
                                                <span className="time">just now</span>
                                                <span className="details">
                                                    <span className="notification-icon circle deepPink-bgcolor"><i
                                                        className="fa fa-check"></i></span>
                                                    Congratulations!. </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:;">
                                                <span className="time">3 mins</span>
                                                <span className="details">
                                                    <span className="notification-icon circle purple-bgcolor"><i
                                                        className="fa fa-user o"></i></span>
                                                    <b>John Micle </b>is now following you. </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:;">
                                                <span className="time">7 mins</span>
                                                <span className="details">
                                                    <span className="notification-icon circle blue-bgcolor"><i
                                                        className="fa fa-comments-o"></i></span>
                                                    <b>Sneha Jogi </b>sent you a message. </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:;">
                                                <span className="time">12 mins</span>
                                                <span className="details">
                                                    <span className="notification-icon circle pink"><i
                                                        className="fa fa-heart"></i></span>
                                                    <b>Ravi Patel </b>like your photo. </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:;">
                                                <span className="time">15 mins</span>
                                                <span className="details">
                                                    <span className="notification-icon circle yellow"><i
                                                        className="fa fa-warning"></i></span> Warning! </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:;">
                                                <span className="time">10 hrs</span>
                                                <span className="details">
                                                    <span className="notification-icon circle red"><i
                                                        className="fa fa-times"></i></span> Application error. </span>
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="dropdown-menu-footer">
                                        <a href="javascript:void(0)"> All notifications </a>
                                    </div>
                                </li>
                            </ul>
                        </li>
                        {/* <!-- end notification dropdown --> */}
                        {/* <!-- start message dropdown --> */}
                        <li className="dropdown dropdown-extended dropdown-inbox" id="header_inbox_bar">

                            <ul className="dropdown-menu">
                                <li className="external">
                                    <h3><span className="bold">Messages</span></h3>
                                    <span className="notification-label cyan-bgcolor">New 2</span>
                                </li>
                                <li>
                                    <ul className="dropdown-menu-list small-slimscroll-style" data-handle-color="#637283">
                                        <li>
                                            <a href="#">
                                                <span className="photo">
                                                    <img src="img/doc/doc2.jpg" className="img-circle" alt="" />
                                                </span>
                                                <span className="subject">
                                                    <span className="from"> Sarah Smith </span>
                                                    <span className="time">Just Now </span>
                                                </span>
                                                <span className="message"> Jatin I found you on LinkedIn... </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <span className="photo">
                                                    <img src="img/doc/doc3.jpg" className="img-circle" alt="" />
                                                </span>
                                                <span className="subject">
                                                    <span className="from"> John Deo </span>
                                                    <span className="time">16 mins </span>
                                                </span>
                                                <span className="message"> Fwd: Important Notice Regarding Your Domain
                                                    Name... </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <span className="photo">
                                                    <img src="img/doc/doc1.jpg" className="img-circle" alt="" />
                                                </span>
                                                <span className="subject">
                                                    <span className="from"> Rajesh </span>
                                                    <span className="time">2 hrs </span>
                                                </span>
                                                <span className="message"> pls take a print of attachments. </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <span className="photo">
                                                    <img src="img/doc/doc8.jpg" className="img-circle" alt="" />
                                                </span>
                                                <span className="subject">
                                                    <span className="from"> Lina Smith </span>
                                                    <span className="time">40 mins </span>
                                                </span>
                                                <span className="message"> Apply for Ortho Surgeon </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <span className="photo">
                                                    <img src="img/doc/doc5.jpg" className="img-circle" alt="" />
                                                </span>
                                                <span className="subject">
                                                    <span className="from"> Jacob Ryan </span>
                                                    <span className="time">46 mins </span>
                                                </span>
                                                <span className="message"> Request for leave application. </span>
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="dropdown-menu-footer">
                                        <a href="#"> All Messages </a>
                                    </div>
                                </li>
                            </ul>
                        </li>
                        {/* <!-- end message dropdown --> */}
                        {/* <!-- start manage user dropdown --> */}
                        <li className="dropdown dropdown-user">

                            <a className="dropdown-toggle" data-bs-toggle="dropdown" data-hover="dropdown"
                                data-close-others="true">
                                {/* <img alt="" className="img-circle " src="img/dp.jpg" /> */}

                                <span className="username username-hide-on-mobile" />
                                {firstname} {lastname}
                            </a>
                            <ul className="dropdown-menu dropdown-menu-default">
                                <li>
                                    {/* <a href="user_profile.html">
                                        <i className="icon-user"></i> Profile </a>
                                         */}
                                    <Link to='/UpdateManager'>

                                        <i className="icon-user"></i> Profile
                                        {/* <span className="selected"></span> */}
                                    </Link>

                                </li>
                                {/* <li>
                                    <a href="#">
                                        <i className="icon-settings"></i> Settings
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <i className="icon-directions"></i> Help
                                    </a>
                                </li>
                                <li className="divider"> </li>
                                <li>
                                    <a href="lock_screen.html">
                                        <i className="icon-lock"></i> Lock
                                    </a>
                                </li> */}
                                <li>
                                    <a onClick={Logout}>
                                        <i className="icon-logout"></i> Log Out </a>
                                </li>
                            </ul>
                        </li>
                        {/* <!-- end manage user dropdown --> */}
                        <li className="dropdown dropdown-quick-sidebar-toggler">
                            {/* <a id="headerSettingButton" className="mdl-button mdl-js-button mdl-button--icon pull-right"
                                data-upgraded=",MaterialButton">
                                <i className="material-icons">more_vert</i>
                            </a> */}
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default ManagerNavbar;